import { cn } from "@lib/cn";
import { VERSIONS_TABLE_SIZES } from "@pages/analytics/constants";

export const VersionTableRowSkeleton = ({
  skipLoading,
}: {
  skipLoading?: boolean;
}) => {
  return (
    <div className="tw-flex tw-items-center tw-bg-white tw-border-b tw-border-solid tw-border-blue-100 tw-py-0.5 tw-h-[53px] last:tw-border-b-0">
      {/* Name column */}
      <div className="tw-flex-auto tw-px-2 tw-pl-4 tw-py-3 tw-flex tw-items-center tw-gap-3">
        <span
          className={cn(
            "tw-size-6 tw-block tw-rounded-md tw-bg-blue-100/50 tw-flex-shrink-0",
            !skipLoading && "tw-animate-skeleton-loading",
          )}
        ></span>
        <div className="tw-flex tw-flex-col tw-gap-2 tw-min-w-0">
          <span
            className={cn(
              "tw-block tw-h-1.5 tw-w-32 tw-rounded-lg tw-bg-blue-100/50",
              !skipLoading && "tw-animate-skeleton-loading",
            )}
          ></span>
          <span
            className={cn(
              "tw-block tw-h-1.5 tw-w-24 tw-rounded-lg tw-bg-blue-100/50",
              !skipLoading && "tw-animate-skeleton-loading",
            )}
          ></span>
        </div>
      </div>

      {/* Readers column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SIZES.READERS }}
      >
        <span
          className={cn(
            "tw-block tw-h-1.5 tw-w-6 tw-rounded tw-bg-blue-100/50",
            !skipLoading && "tw-animate-skeleton-loading",
          )}
        ></span>
      </div>

      {/* Avg reading time column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SIZES.AVG_READING_TIME }}
      >
        <span
          className={cn(
            "tw-block tw-h-1.5 tw-w-10 tw-rounded tw-bg-blue-100/50",
            !skipLoading && "tw-animate-skeleton-loading",
          )}
        ></span>
      </div>

      {/* Engaged users column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SIZES.ENGAGED_USERS }}
      >
        <span
          className={cn(
            "tw-block tw-h-1.5 tw-w-6 tw-rounded tw-bg-blue-100/50",
            !skipLoading && "tw-animate-skeleton-loading",
          )}
        ></span>
      </div>

      {/* Avg progress column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-gap-2 tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SIZES.AVG_PROGRESS }}
      >
        <span
          className={cn(
            "tw-size-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-blue-100/50",
            !skipLoading && "tw-animate-skeleton-loading",
          )}
        >
          <span className="tw-size-4 tw-block tw-rounded-full tw-bg-white"></span>
        </span>
        <span
          className={cn(
            "tw-block tw-h-1.5 tw-w-6 tw-rounded-lg tw-bg-blue-100/50",
            !skipLoading && "tw-animate-skeleton-loading",
          )}
        ></span>
      </div>

      {/* Created at column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SIZES.CREATED_AT }}
      >
        <span
          className={cn(
            "tw-block tw-h-1.5 tw-w-20 tw-rounded-lg tw-bg-blue-100/50",
            !skipLoading && "tw-animate-skeleton-loading",
          )}
        ></span>
      </div>

      {/* Owner column */}
      <div
        className="tw-flex tw-items-center tw-gap-3 tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SIZES.OWNER }}
      >
        <div className="tw-px-2 tw-w-12 tw-flex tw-items-center tw-justify-end">
          <span
            className={cn(
              "tw-size-8 tw-block tw-rounded-full tw-bg-blue-100/50",
              !skipLoading && "tw-animate-skeleton-loading",
            )}
          ></span>
        </div>
      </div>
    </div>
  );
};
